<div class="contentblock">
  <h3>Additional</h3>

  <div class="form-group row">
    <label for="label" class="col-sm-2 col-form-label">Is additional</label>
    <div class="col-sm-10">
      <kendo-switch
        name="isAdditional"
        [(ngModel)]="item.isAdditional"
        (valueChange)="onChangeAdditional()"
      ></kendo-switch>
    </div>
  </div>
</div>
